<template>
    <ag-grid-vue :id="gridId"
        class="bsp-ag-grid-custom prev-custom new"
        data-custom="new"
        :gridOptions="gridOptions"
        :rowData="rowData"
        :overlayNoRowsTemplate="overlayNoRowsTemplate"
        :style="getCustomStyle"
        :enableBrowserTooltips="true"
        @selection-changed="onChecked"
        @column-resized="onColumnResized"
        @grid-ready="onGridReady">
    </ag-grid-vue>
</template>

<script>
    import { EventBus } from "../common/event-bus";
    import {AgGridVue} from "ag-grid-vue";
    export default {
        name: 'AgWhitelist',
        components: {
            AgGridVue
        },
        props: {
            gridId: String,                     // Component 고유 아이디
            rowData: Array,                     // Row Data (List)
            customStyle: String,                // 사용자 정의 Style
            overlayNoRowsTemplate: {
                type: String,
                default: "<p class='overlay-nodata'><span>검색 결과가 없습니다.</span></p>", //검색 결과가 없습니다.
            },                             // 데이터 없을 시 표시되는 템플릿
            selectedRows: {
                type: Array,
                default: ()=>[]
            }
        },
        data: function() {
            return {
                gridOptions: null,
                gridApi:null,
            }
        },
        created: function() {
            this.setGridOptions()
        },
        mounted: function() {
            this.gridApi = this.gridOptions.api;
            this.setSelectedRows();
            EventBus.$on("changeLocale", e => {
                //this.gridOptions.columnDefs =

                //console.log(this.gridOptions)
               // this.gridApi.setColumnDefs(this.createColDefs())
                this.gridApi.sizeColumnsToFit()
            });
        },
        computed: {
            getCustomStyle: function() {
                return typeof(this.customStyle) !== 'undefined' ? this.customStyle : '';
            }
        },
        methods: {
            setSelectedRows(){
                if (this.selectedRows) {
                    const self = this;
                    this.gridApi.forEachNode(node => {
                    // select the node
                    if (self.isContainNode(self.selectedRows, node.data)) {
                        node.setSelected(true);
                    }
                });
                }
            },
            isContainNode(array, object) {
                if (_.find(array, node => {return _.isEqual(node, object)})) {
                    return true;
                }
                return false;
            },
            setGridOptions: function() {
                // grid settings
                this.gridOptions = {
                    defaultColDef: {
                        headerComponentParams: {
                            menuIcon: 'fa-bars'
                        },
                        sortable: true,
                        resizable: true,
                        filter: true
                    },
                    columnDefs: this.createColDefs(),
                    suppressMenuHide: true,
                    rowData: null,
                    rowSelection: 'multiple',
                    unSortIcon:true,
                    groupSelectsChildren: true,
                    suppressRowClickSelection: true,
                    suppressPropertyNamesCheck: true,
                    onGridReady : function(params){
                        params.api.sizeColumnsToFit();
                        window.addEventListener('resize', function() {
                            setTimeout(function() {
                                params.api.sizeColumnsToFit();
                            })
                        })
                    },
                    headerHeight: 30,
                    icons: {
                        checkboxChecked: '<img src="/assets/images/ag-grid/checkbox_checked.png">',
                        checkboxUnchecked: '<img src="/assets/images/ag-grid/checkbox_normal.png">',
                        checkboxIndeterminate: '<img src="/assets/images/ag-grid/checkbox_indeterminate.png">'
                    },

                    getRowHeight: function(params) {
                        return 31
                    }
                }
            },
            createColDefs() {
                const self = this;
                return [
                    {
                        headerName: "",
                        field: "Checkbox",
                        unSortIcon: false,
                        filter:false,
                        suppressMenu: true,
                        cellClass: 'align-center',
                        headerCheckboxSelection: true,
                        headerCheckboxSelectionFilteredOnly: true,
                        checkboxSelection: true,
                        sortable: false,
                        width:35,
                        cellRenderer: function(params){
                            if(params.value === 'checkbox' ){
                                return '';
                            }
                        }
                    },{
                        headerName: this.$t("SETTING.WHITELIST.TABLE.VENDOR"), // 적용 지역
                        field: "Vendor",
                        width:120,
                        suppressMenu: true,
                        headerComponentParams:true,
                        cellStyle: {'text-align' : 'center'},
                        cellRenderer: function(params) {
                            params.rowIndex = params.rowIndex+1;
                            // TODO:Multi vendor 추후 적용 예정
                            let vendor = _.get(params, 'data.vndr', '');
                            vendor = self.Common.getVendorByKey(vendor);
                            return `<span class="icon-vender txt-none" data-vendor="${vendor}" data-size="s" :title="${vendor}">${vendor}</span>`;
                        }
                    },{
                        headerName: this.$t("SETTING.WHITELIST.TABLE.ACCOUNT"), // 제품 (OS)
                        field: 'accId',
                        tooltipField: 'accId',
                        cellRenderer: function(params) {

                            return `${params.data.accId}(${params.data.accAlias})`

                        }
                    },{
                        headerName: this.$t("SETTING.WHITELIST.TABLE.PRODUCT"), // 패밀리 유형
                        field: 'rsrcType',
                        tooltipField: 'rsrcType'
                    },{
                        headerName: this.$t("SETTING.WHITELIST.TABLE.REGION"), // 크기
                        field: 'rgnId',
                        unSortIcon: true,
                        tooltipField: 'rgnId',
                        cellRenderer: function(params) {
                            const rgn = params.data.rgnId;
                            if (self.$te('COMMON.REGION.' + rgn)) {
                                return self.$t('COMMON.REGION.' + rgn);
                            }
                            return rgn;
                        }
                    },{
                        headerName: this.$t("SETTING.WHITELIST.TABLE.RESOURCE"), // 크기
                        field: 'instId',
                        unSortIcon: true,
                        tooltipField: 'instId'
                    }

                ]
            },
            onColumnResized() {
                this.gridApi.resetRowHeights();
            },
            // checkbox 클릭했을때 이벤트
            onChecked() {
                const rows = this.gridOptions.api.getSelectedRows();
                this.$emit('onChecked', {'id': this.gridId, 'value': rows});
            },
            onGridReady() {
                $('.ag-body-viewport').addClass('ag-body')
            },
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/ag-grid/ag-whitelist.vue